export default __webpack_public_path__ + "static/media/query_card_1.bb0378a6.png";